export const MIX_N_BATCH_LOGO_C_FILENAME = 'logo_purple.png';

export const mixNBatchLogoCUrl = `/logo/${encodeURIComponent(MIX_N_BATCH_LOGO_C_FILENAME)}`;
